var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"OurTabs",staticClass:"tabs",class:_vm.tabsClass,attrs:{"data-cy":_vm.dataCy}},[_vm._t("default",function(){return _vm._l((_vm.options),function(item,index){return _c('OurTab',{key:item.value,attrs:{"label":item.label,"value":item.value,"disabled":item.disabled,"size":_vm.size,"data-cy":`${_vm.dataCy}-item-${index}`}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }